module.exports = __webpack_public_path__ + "img/helen_marie.c0eea624.png";